import { downloadCenterApi as api } from './downloadCenterApi';
export const addTagTypes = ['account_details'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      accountDetailsDownloadCentreList: build.query<
        AccountDetailsDownloadCentreListApiResponse,
        AccountDetailsDownloadCentreListApiArg
      >({
        query: queryArg => ({
          url: `/account_details/download_centre/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['account_details']
      }),
      accountDetailsDownloadCentreDeleteMultiple: build.mutation<
        AccountDetailsDownloadCentreDeleteMultipleApiResponse,
        AccountDetailsDownloadCentreDeleteMultipleApiArg
      >({
        query: queryArg => ({
          url: `/account_details/download_centre/delete_multiple/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['account_details']
      }),
      accountDetailsDownloadCentreDelete: build.mutation<
        AccountDetailsDownloadCentreDeleteApiResponse,
        AccountDetailsDownloadCentreDeleteApiArg
      >({
        query: queryArg => ({
          url: `/account_details/download_centre/${queryArg.uuid}/`,
          method: 'DELETE'
        }),
        invalidatesTags: ['account_details']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type AccountDetailsDownloadCentreListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: DownloadCentreRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type AccountDetailsDownloadCentreListApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AccountDetailsDownloadCentreDeleteMultipleApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: DownloadCentreRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type AccountDetailsDownloadCentreDeleteMultipleApiArg = {
  body: {
    /** List of file UUIDs to delete */
    file_uuids: string[];
  };
};
export type AccountDetailsDownloadCentreDeleteApiResponse =
  /** status 200 Custom Response */ {
    results: DownloadCentreRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type AccountDetailsDownloadCentreDeleteApiArg = {
  uuid: string;
};
export type DownloadCentre = {
  name: string;
  url?: string | null;
  created_by?: string;
  file_type?: string | null;
  file_size?: string;
  model_type?: string | null;
  fields?: string | null;
  filters?: object | null;
};
export type DownloadCentreRead = {
  uuid?: string;
  id?: number;
  name: string;
  url?: string | null;
  created_by?: string;
  created_at?: string;
  file_type?: string | null;
  file_size?: string;
  status?: 'inprogress' | 'downloadable';
  model_type?: string | null;
  fields?: string | null;
  filters?: object | null;
};
export const {
  useAccountDetailsDownloadCentreListQuery,
  useAccountDetailsDownloadCentreDeleteMultipleMutation,
  useAccountDetailsDownloadCentreDeleteMutation
} = injectedRtkApi;
